const TARGET = {
  key: "TARGET",
  defaultText: "Target"
};
const DEVIATION = {
  key: "DEVIATION",
  defaultText: "Deviation"
};
const ABORT = {
  key: "ABORT",
  defaultText: "Abort"
};
const CANCEL = {
  key: "CANCEL",
  defaultText: "Cancel"
};
const CLOSE = {
  key: "CLOSE",
  defaultText: "Close"
};
const DELETE = {
  key: "DELETE",
  defaultText: "Delete"
};
const IGNORE = {
  key: "IGNORE",
  defaultText: "Ignore"
};
const NO = {
  key: "NO",
  defaultText: "No"
};
const OK = {
  key: "OK",
  defaultText: "OK"
};
const RETRY = {
  key: "RETRY",
  defaultText: "Retry"
};
const YES = {
  key: "YES",
  defaultText: "Yes"
};
const CLEAR_SORTING = {
  key: "CLEAR_SORTING",
  defaultText: "Clear Sorting"
};
const SORT_ASCENDING = {
  key: "SORT_ASCENDING",
  defaultText: "Sort Ascending"
};
const SORT_DESCENDING = {
  key: "SORT_DESCENDING",
  defaultText: "Sort Descending"
};
const GROUP = {
  key: "GROUP",
  defaultText: "Group"
};
const GROUPED = {
  key: "GROUPED",
  defaultText: "Grouped"
};
const UNGROUP = {
  key: "UNGROUP",
  defaultText: "Ungroup"
};
const DRAG_TO_RESIZE = {
  key: "DRAG_TO_RESIZE",
  defaultText: "Drag to resize"
};
const PLEASE_WAIT = {
  key: "PLEASE_WAIT",
  defaultText: "Please wait"
};
const CONFIRMATION = {
  key: "CONFIRMATION",
  defaultText: "Confirmation"
};
const ERROR = {
  key: "ERROR",
  defaultText: "Error"
};
const INFORMATION = {
  key: "INFORMATION",
  defaultText: "Information"
};
const SUCCESS = {
  key: "SUCCESS",
  defaultText: "Success"
};
const WARNING = {
  key: "WARNING",
  defaultText: "Warning"
};
const SHOW_LESS = {
  key: "SHOW_LESS",
  defaultText: "Show less"
};
const SHOW_MORE = {
  key: "SHOW_MORE",
  defaultText: "Show more"
};
const EXPAND_GROUP = {
  key: "EXPAND_GROUP",
  defaultText: "Expand Group"
};
const COLLAPSE_GROUP = {
  key: "COLLAPSE_GROUP",
  defaultText: "Collapse Group"
};
const SHOW_FILTER_BAR = {
  key: "SHOW_FILTER_BAR",
  defaultText: "Show Filter Bar"
};
const HIDE_FILTER_BAR = {
  key: "HIDE_FILTER_BAR",
  defaultText: "Hide Filter Bar"
};
const CLEAR = {
  key: "CLEAR",
  defaultText: "Clear"
};
const RESTORE = {
  key: "RESTORE",
  defaultText: "Restore"
};
const FILTERS = {
  key: "FILTERS",
  defaultText: "Filters"
};
const ADAPT_FILTERS = {
  key: "ADAPT_FILTERS",
  defaultText: "Adapt Filters"
};
const GO = {
  key: "GO",
  defaultText: "Go"
};
const SAVE = {
  key: "SAVE",
  defaultText: "Save"
};
const SHOW_ON_FILTER_BAR = {
  key: "SHOW_ON_FILTER_BAR",
  defaultText: "Show on Filter Bar"
};
const BASIC = {
  key: "BASIC",
  defaultText: "Basic"
};
const SEARCH_FOR_FILTERS = {
  key: "SEARCH_FOR_FILTERS",
  defaultText: "Search for filters"
};
const FIELDS_BY_ATTRIBUTE = {
  key: "FIELDS_BY_ATTRIBUTE",
  defaultText: "Show Fields by Attribute"
};
const VISIBLE = {
  key: "VISIBLE",
  defaultText: "Visible"
};
const ACTIVE = {
  key: "ACTIVE",
  defaultText: "Active"
};
const VISIBLE_AND_ACTIVE = {
  key: "VISIBLE_AND_ACTIVE",
  defaultText: "Visible and Active"
};
const MANDATORY = {
  key: "MANDATORY",
  defaultText: "Mandatory"
};
const LIST_VIEW = {
  key: "LIST_VIEW",
  defaultText: "List View"
};
const GROUP_VIEW = {
  key: "GROUP_VIEW",
  defaultText: "Group View"
};
const SHOW_VALUES = {
  key: "SHOW_VALUES",
  defaultText: "Show Values"
};
const HIDE_VALUES = {
  key: "HIDE_VALUES",
  defaultText: "Hide Values"
};
const FIELD = {
  key: "FIELD",
  defaultText: "Field"
};
const COLLAPSE_HEADER = {
  key: "COLLAPSE_HEADER",
  defaultText: "Collapse Header"
};
const EXPAND_HEADER = {
  key: "EXPAND_HEADER",
  defaultText: "Expand Header"
};
const PIN_HEADER = {
  key: "PIN_HEADER",
  defaultText: "Pin Header"
};
const UNPIN_HEADER = {
  key: "UNPIN_HEADER",
  defaultText: "Unpin Header"
};
const SEPARATOR = {
  key: "SEPARATOR",
  defaultText: "Separator"
};
const AVAILABLE_ACTIONS = {
  key: "AVAILABLE_ACTIONS",
  defaultText: "Available Actions"
};
const X_OF_Y = {
  key: "X_OF_Y",
  defaultText: "Item {0} of {1}"
};
const MY_VIEWS = {
  key: "MY_VIEWS",
  defaultText: "My Views"
};
const SAVE_VIEW = {
  key: "SAVE_VIEW",
  defaultText: "Save View"
};
const MANAGE_VIEWS = {
  key: "MANAGE_VIEWS",
  defaultText: "Manage Views"
};
const VIEW = {
  key: "VIEW",
  defaultText: "View"
};
const VARIANT_MANAGEMENT_ERROR_DUPLICATE = {
  key: "VARIANT_MANAGEMENT_ERROR_DUPLICATE",
  defaultText: "The view name already exists. Please enter a different name."
};
const SPECIFY_VIEW_NAME = {
  key: "SPECIFY_VIEW_NAME",
  defaultText: "Please specify a view name"
};
const SET_AS_DEFAULT = {
  key: "SET_AS_DEFAULT",
  defaultText: "Set as Default"
};
const PUBLIC = {
  key: "PUBLIC",
  defaultText: "Public"
};
const APPLY_AUTOMATICALLY = {
  key: "APPLY_AUTOMATICALLY",
  defaultText: "Apply Automatically"
};
const SHARING = {
  key: "SHARING",
  defaultText: "Sharing"
};
const DEFAULT = {
  key: "DEFAULT",
  defaultText: "Default"
};
const CREATED_BY = {
  key: "CREATED_BY",
  defaultText: "Created By"
};
const MANAGE = {
  key: "MANAGE",
  defaultText: "Manage"
};
const PRIVATE = {
  key: "PRIVATE",
  defaultText: "Private"
};
const MARK_AS_STANDARD = {
  key: "MARK_AS_STANDARD",
  defaultText: "Use as standard view"
};
const MARK_AS_FAVORITE = {
  key: "MARK_AS_FAVORITE",
  defaultText: "Mark as favorite view"
};
const DELETE_VIEW = {
  key: "DELETE_VIEW",
  defaultText: "Delete view"
};
const SELECT_VIEW = {
  key: "SELECT_VIEW",
  defaultText: "Select view"
};
const SEARCH_VARIANT = {
  key: "SEARCH_VARIANT",
  defaultText: "Search variant"
};
const ALL = {
  key: "ALL",
  defaultText: "All"
};
const SEARCH = {
  key: "SEARCH",
  defaultText: "Search"
};
const SAVE_AS = {
  key: "SAVE_AS",
  defaultText: "Save As"
};
const RESET = {
  key: "RESET",
  defaultText: "Reset"
};
const SELECTED_AS_FAVORITE = {
  key: "SELECTED_AS_FAVORITE",
  defaultText: "Selected as Favorite"
};
const UNSELECTED_AS_FAVORITE = {
  key: "UNSELECTED_AS_FAVORITE",
  defaultText: "Unselected as Favorite"
};
const SELECT = {
  key: "SELECT",
  defaultText: "Select"
};
const SELECTED = {
  key: "SELECTED",
  defaultText: "Selected"
};
const PRESS_ARROW_KEYS_TO_MOVE = {
  key: "PRESS_ARROW_KEYS_TO_MOVE",
  defaultText: "Press ARROW keys to move"
};
const LIST_NO_DATA = {
  key: "LIST_NO_DATA",
  defaultText: "No data"
};
const EXPAND_NODE = {
  key: "EXPAND_NODE",
  defaultText: "Expand Node"
};
const COLLAPSE_NODE = {
  key: "COLLAPSE_NODE",
  defaultText: "Collapse Node"
};
const EXPAND_PRESS_SPACE = {
  key: "EXPAND_PRESS_SPACE",
  defaultText: "To expand the row, press the spacebar"
};
const COLLAPSE_PRESS_SPACE = {
  key: "COLLAPSE_PRESS_SPACE",
  defaultText: "To collapse the row, press the spacebar"
};
const SELECT_PRESS_SPACE = {
  key: "SELECT_PRESS_SPACE",
  defaultText: "To select the row, press the spacebar"
};
const UNSELECT_PRESS_SPACE = {
  key: "UNSELECT_PRESS_SPACE",
  defaultText: "To deselect the row, press the spacebar"
};
const INVALID_TABLE = {
  key: "INVALID_TABLE",
  defaultText: "Invalid Table"
};
const FILTERED = {
  key: "FILTERED",
  defaultText: "Filtered"
};
const ARIA_DESC_CARD_HEADER = {
  key: "ARIA_DESC_CARD_HEADER",
  defaultText: "Card Header"
};
const SEMANTIC_COLOR_CRITICAL = {
  key: "SEMANTIC_COLOR_CRITICAL",
  defaultText: "Warning"
};
const SEMANTIC_COLOR_GOOD = {
  key: "SEMANTIC_COLOR_GOOD",
  defaultText: "Good"
};
const SEMANTIC_COLOR_NEUTRAL = {
  key: "SEMANTIC_COLOR_NEUTRAL",
  defaultText: "Neutral"
};
const SEMANTIC_COLOR_ERROR = {
  key: "SEMANTIC_COLOR_ERROR",
  defaultText: "Critical"
};
const NUMERICCONTENT_DEVIATION_UP = {
  key: "NUMERICCONTENT_DEVIATION_UP",
  defaultText: "Ascending"
};
const NUMERICCONTENT_DEVIATION_DOWN = {
  key: "NUMERICCONTENT_DEVIATION_DOWN",
  defaultText: "Descending"
};
const ARIA_OBJ_STATUS_DESC = {
  key: "ARIA_OBJ_STATUS_DESC",
  defaultText: "Object Status Button"
};
const ARIA_OBJ_STATUS_DESC_INACTIVE = {
  key: "ARIA_OBJ_STATUS_DESC_INACTIVE",
  defaultText: "Object Status"
};
const INDICATION_COLOR = {
  key: "INDICATION_COLOR",
  defaultText: "Indication Color"
};
const EMPTY_VALUE = {
  key: "EMPTY_VALUE",
  defaultText: "Empty Value"
};
const SELECT_ALL = {
  key: "SELECT_ALL",
  defaultText: "Select All"
};
const DESELECT_ALL = {
  key: "DESELECT_ALL",
  defaultText: "Deselect All"
};
const SHOW_FULL_TEXT = {
  key: "SHOW_FULL_TEXT",
  defaultText: "Show the full text"
};
const CLOSE_POPOVER = {
  key: "CLOSE_POPOVER",
  defaultText: "Close the popover"
};
export { TARGET, DEVIATION, ABORT, CANCEL, CLOSE, DELETE, IGNORE, NO, OK, RETRY, YES, CLEAR_SORTING, SORT_ASCENDING, SORT_DESCENDING, GROUP, GROUPED, UNGROUP, DRAG_TO_RESIZE, PLEASE_WAIT, CONFIRMATION, ERROR, INFORMATION, SUCCESS, WARNING, SHOW_LESS, SHOW_MORE, EXPAND_GROUP, COLLAPSE_GROUP, SHOW_FILTER_BAR, HIDE_FILTER_BAR, CLEAR, RESTORE, FILTERS, ADAPT_FILTERS, GO, SAVE, SHOW_ON_FILTER_BAR, BASIC, SEARCH_FOR_FILTERS, FIELDS_BY_ATTRIBUTE, VISIBLE, ACTIVE, VISIBLE_AND_ACTIVE, MANDATORY, LIST_VIEW, GROUP_VIEW, SHOW_VALUES, HIDE_VALUES, FIELD, COLLAPSE_HEADER, EXPAND_HEADER, PIN_HEADER, UNPIN_HEADER, SEPARATOR, AVAILABLE_ACTIONS, X_OF_Y, MY_VIEWS, SAVE_VIEW, MANAGE_VIEWS, VIEW, VARIANT_MANAGEMENT_ERROR_DUPLICATE, SPECIFY_VIEW_NAME, SET_AS_DEFAULT, PUBLIC, APPLY_AUTOMATICALLY, SHARING, DEFAULT, CREATED_BY, MANAGE, PRIVATE, MARK_AS_STANDARD, MARK_AS_FAVORITE, DELETE_VIEW, SELECT_VIEW, SEARCH_VARIANT, ALL, SEARCH, SAVE_AS, RESET, SELECTED_AS_FAVORITE, UNSELECTED_AS_FAVORITE, SELECT, SELECTED, PRESS_ARROW_KEYS_TO_MOVE, LIST_NO_DATA, EXPAND_NODE, COLLAPSE_NODE, EXPAND_PRESS_SPACE, COLLAPSE_PRESS_SPACE, SELECT_PRESS_SPACE, UNSELECT_PRESS_SPACE, INVALID_TABLE, FILTERED, ARIA_DESC_CARD_HEADER, SEMANTIC_COLOR_CRITICAL, SEMANTIC_COLOR_GOOD, SEMANTIC_COLOR_NEUTRAL, SEMANTIC_COLOR_ERROR, NUMERICCONTENT_DEVIATION_UP, NUMERICCONTENT_DEVIATION_DOWN, ARIA_OBJ_STATUS_DESC, ARIA_OBJ_STATUS_DESC_INACTIVE, INDICATION_COLOR, EMPTY_VALUE, SELECT_ALL, DESELECT_ALL, SHOW_FULL_TEXT, CLOSE_POPOVER };